import React from 'react';

import { CmScrollBox } from '@/components/uiParts';
import { DeliveryServiceName } from '@/domain/models/DeliveryService';
import {
  LinkedStoreItem,
  LinkItemsDividedByDeliveryService,
} from '@/domain/models/LinkItem';
import { DIVIDED_CONTENT_WIDTH } from '@/pages/link-items/LinkItemsPage';

import { AccordionWrapper } from './AccordionWrapper';

interface Props {
  minusHeight: number;
  isDisabledAddButton: boolean;
  uniqueLinkedStoreItemIdsByGroups: string[];
  linkItems: LinkItemsDividedByDeliveryService[];
  deliveryServices: DeliveryServiceName[];
  handleToggleAccordion: (deliveryService: DeliveryServiceName) => void;
  handleAddItemToLinkedGroup: (linkedStoreItem: LinkedStoreItem) => void;
}

export const AccordionArea: React.FC<Props> = ({
  minusHeight,
  isDisabledAddButton,
  uniqueLinkedStoreItemIdsByGroups,
  linkItems,
  deliveryServices,
  handleToggleAccordion,
  handleAddItemToLinkedGroup,
}) => {
  return (
    <CmScrollBox
      width={DIVIDED_CONTENT_WIDTH}
      height={`calc(100vh - ${minusHeight}px)`}
    >
      <AccordionWrapper
        {...{
          isDisabledAddButton,
          uniqueLinkedStoreItemIdsByGroups,
          linkItems,
          deliveryServices,
          handleToggleAccordion,
          handleAddItemToLinkedGroup,
        }}
      />
    </CmScrollBox>
  );
};
